module.exports = __webpack_public_path__ + "static/img/PUBG MOBILE.e2c1397d.png";